"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const multiply = (base) => (factor) => base * factor;
function createSpacing(initialSpacing) {
    const multiplyByFactor = multiply(initialSpacing);
    return function spacing(...args) {
        if (args.length === 0)
            return `${initialSpacing}px`;
        if (args.length === 1 && typeof args[0] === 'number')
            return `${multiplyByFactor(args[0])}px`;
        return args
            .map((factor) => {
            const output = multiplyByFactor(factor);
            return typeof output === 'number' ? `${output}px` : output;
        })
            .join(' ');
    };
}
exports.createSpacing = createSpacing;
